import { render } from "./DbaasWidget.vue?vue&type=template&id=4f8813cf&scoped=true"
import script from "./DbaasWidget.vue?vue&type=script&lang=js"
export * from "./DbaasWidget.vue?vue&type=script&lang=js"

import "./DbaasWidget.vue?vue&type=style&index=0&id=4f8813cf&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8813cf"]])

export default __exports__
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerGears,QIcon});
